import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IAttractionsDetails,
  IAttractionsInitialState,
} from "./attractionsModal";
import {
  ActiveInactiveAttractions,
  AttractionsImageUpload,
  createAttractions,
  deleteAttractions,
  deleteAttractionsImage,
  getAllActiveAttractions,
  getAllAttractions,
  getAttractionsByID,
  updateAttractions,
} from "./services/attractions.services";

const initialState: IAttractionsInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  AttractionsID: null,
  AttractionsList: [],
  AttractionsDetail: {
    ID: null,
    Title: "",
    AttractionURL: "",
    PropertyID: null,
    AttractionCategory: "",
    TagLine: "",
    Distance: "",
    TravelTime: "",
    BestTime: "",
    Duration: "",
    Description: "",
    Dos: "",
    Donts: "",
    MainImage: "",
    BannerImage: "",
    MetaTitle: "",
    MetaDescription: "",
    MetaKeywords: "",
    IsActive: 1,

    BestTimes: [],
    HowToReach: [],
    ThingsToDo: [],
    WhyVisit: [],
    Nearby: [],
    Images: [],
  },
};

const attractionsSlice = createSlice({
  name: "attractions",
  initialState,
  reducers: {
    clearAttractionsDetails: (state) => {
      state.AttractionsDetail = initialState.AttractionsDetail;
    },
    setAttractionsID: (state, action) => {
      state.AttractionsID = action.payload;
    },
    clearAttractionsID: (state) => {
      state.AttractionsID = initialState.AttractionsID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllAttractions.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllAttractions.fulfilled,
      (state, action: PayloadAction<IAttractionsDetails[]>) => {
        state.loading = false;
        state.AttractionsList = action.payload || [];
      },
    );
    builder.addCase(getAllAttractions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AttractionsList = [];
    });
    builder.addCase(createAttractions.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createAttractions.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createAttractions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateAttractions.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateAttractions.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateAttractions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteAttractions.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteAttractions.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteAttractions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteAttractionsImage.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteAttractionsImage.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteAttractionsImage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAttractionsByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAttractionsByID.fulfilled,
      (state, action: PayloadAction<IAttractionsDetails>) => {
        state.loading = false;
        state.AttractionsDetail = action.payload;
      },
    );
    builder.addCase(getAttractionsByID.rejected, (state, action) => {
      state.loading = false;
      state.AttractionsDetail = initialState.AttractionsDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveAttractions.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveAttractions.fulfilled,
      (state, action: PayloadAction<IAttractionsDetails[]>) => {
        state.loading = false;
        state.AttractionsList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveAttractions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AttractionsList = [];
    });
    builder.addCase(ActiveInactiveAttractions.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveAttractions.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveAttractions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(AttractionsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(AttractionsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(AttractionsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearAttractionsDetails, clearAttractionsID, setAttractionsID } =
  attractionsSlice.actions;
export default attractionsSlice.reducer;
